import {
  ServiceCredentialModifier,
  ServiceCredentialModifierInterface,
} from './serviceCredentialModifier';
import {PlaceOfService} from './placeOfService';

export interface ServiceInterface {
  id: string;
  name: string;
  description: string;
  applicableState: string;
  billingCode: string;
  billingModifier: string;
  secondaryModifier: string;
  blocksTimeEntry: boolean;
  licenseChangesBillingModifier: boolean;
  licenseRequiredForService: boolean;
  programId: string;
  defaultPlaceOfServiceId: string;
  defaultPlaceOfService?: PlaceOfService;
  placeOfServiceIds: string[];
  serviceCredentialModifiers?: ServiceCredentialModifierInterface[];
  serviceCredentialModifiersAttributes?: ServiceCredentialModifierInterface[];
  createdAt: string;
  updatedAt: string;
}

export class Service implements ServiceInterface {
  id: string;
  name: string;
  description: string;
  applicableState: string;
  billingCode: string;
  billingModifier: string;
  secondaryModifier: string;
  blocksTimeEntry: boolean;
  licenseChangesBillingModifier: boolean;
  licenseRequiredForService: boolean;
  programId: string;
  defaultPlaceOfServiceId: string;
  defaultPlaceOfService?: PlaceOfService;
  placeOfServiceIds: string[];
  serviceCredentialModifiers?: ServiceCredentialModifier[];
  serviceCredentialModifiersAttributes?: ServiceCredentialModifier[];
  createdAt: string;
  updatedAt: string;

  constructor(data: Partial<ServiceInterface>) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.description = data.description || '';
    this.applicableState = data.applicableState || '';
    this.billingCode = data.billingCode || '';
    this.billingModifier = data.billingModifier || '';
    this.secondaryModifier = data.secondaryModifier || '';
    this.blocksTimeEntry = data.blocksTimeEntry || false;
    this.licenseChangesBillingModifier =
      data.licenseChangesBillingModifier || false;
    this.licenseRequiredForService = data.licenseRequiredForService || false;
    this.programId = data.programId || '';
    this.defaultPlaceOfServiceId = data.defaultPlaceOfServiceId || '';
    this.defaultPlaceOfService = data.defaultPlaceOfService
      ? new PlaceOfService(data.defaultPlaceOfService)
      : undefined;
    this.placeOfServiceIds = data.placeOfServiceIds || [];
    this.serviceCredentialModifiers =
      data.serviceCredentialModifiers?.map(
        modifier => new ServiceCredentialModifier(modifier),
      ) || [];
    this.serviceCredentialModifiersAttributes =
      data.serviceCredentialModifiersAttributes?.map(
        modifier => new ServiceCredentialModifier(modifier),
      ) || [];
    this.createdAt = data.createdAt || '';
    this.updatedAt = data.updatedAt || '';
  }

  toJson(): ServiceInterface {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      applicableState: this.applicableState,
      billingCode: this.billingCode,
      billingModifier: this.billingModifier,
      secondaryModifier: this.secondaryModifier,
      blocksTimeEntry: this.blocksTimeEntry,
      licenseChangesBillingModifier: this.licenseChangesBillingModifier,
      licenseRequiredForService: this.licenseRequiredForService,
      programId: this.programId,
      defaultPlaceOfServiceId: this.defaultPlaceOfServiceId,
      placeOfServiceIds: this.placeOfServiceIds,
      serviceCredentialModifiersAttributes:
        this.serviceCredentialModifiers?.map(modifier => modifier.toJson()),
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }
}
